<template>
  <div class="flex flex-col mb-4">
    <NuxtLink
      class="text-2xl text-primary-lightest hover:text-primary-lighter focus:text-primary-lighter active:text-primary-lighter text-center"
      :to="countyLink"
    >
      {{ county.name }}
    </NuxtLink>

    <NuxtLink
      v-if="!isCapital(county.largestCity)"
      class="text-xl text-white hover:text-primary-lighter focus:text-primary-lighter active:text-primary-lighter text-center"
      :to="largestCityLink"
    >
      {{ county.largestCity.name }}
    </NuxtLink>
  </div>
</template>

<script>
import useCapital from "~/composables/useCapital";

export default {
  props: {
    county: {
      type: Object,
      required: true,
    },
    profession: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { isCapital } = useCapital();
    return {
      isCapital,
    };
  },
  computed: {
    countyLink() {
      return this.localePath({
        name: "professionals",
        params: {
          profession: this.profession.seoName,
          city: this.county.seoName,
        },
      });
    },
    largestCityLink() {
      return this.localePath({
        name: "professionals",
        params: {
          profession: this.profession.seoName,
          city: this.county.largestCity.seoName,
        },
      });
    },
  },
};
</script>
